/**
 * Where a node's page is, decided once.
 *
 * Every tree row and every search hit is a link to a node, and the destination
 * now depends on what the node holds: a document has an editor (§7.4), and a
 * file or a link has only the phase-0 node page, which is the whole of what
 * either is.
 *
 * Spread into a router `Link`:
 *
 * ```tsx
 * <Link {...documentLinkProps(hit.nodeId)}>{hit.title}</Link>
 * ```
 *
 * `as const` is what keeps `to` a literal, which is what lets the router
 * type-check `params` against it — a widened `string` would type-check here and
 * 404 at runtime.
 */

/** A document: its own page, with the body, the review surface, and history. */
export function documentLinkProps(nodeId: string) {
  return { to: '/documents/$nodeId', params: { nodeId } } as const;
}

/** A file or a link node: the node page is the whole of what either has. */
export function nodeLinkProps(nodeId: string) {
  return { to: '/nodes/$nodeId', params: { nodeId } } as const;
}
